import { Component, Input, SimpleChanges } from '@angular/core';
@Component({
  selector: 'empty-state',
  templateUrl: './empty-state.component.html',
  standalone: false
})
export class EmptyStateComponent {
  @Input() title!: string;
  @Input() subTitle: string = '';
  @Input() desc: string = '';
  @Input() img: string = 'assets/images/icons/empty.svg';
  @Input() animationPath: string = '';
  @Input() custClass: string = '';

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.img) {
      this.img = 'assets/images/icons/empty.svg';
    }
  }
}
